import React from "react"
import NumerableIconButton from "../../NumerableIconButton"
import { formatDate } from "../../../modules/utilities"
import { JARGON } from "../../../modules/constants"
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined"

function AccountsMenu(props) {
  // console.log('AccountsMenu props:', props)

  const { externalLinks, hubData, portrait } = props

  const accountsSource = hubData.lseProps
    ? "Accounts on last Annual Report"
    : "Last Accounts on Companies House"

  const tipEnabled = JARGON.EXTERNAL_LINK_TO + accountsSource

  const annualReportButtonLabel = () => {
    const prefix = hubData.lseProps ? "Annual Report" : "Last Accounts"
    return !externalLinks || !hubData.pdfLink
      ? prefix
      // hubData.periodEndOn is companyProfile?.accounts?.lastAccounts?.periodEndOn,
      : `${prefix} (${formatDate(hubData.periodEndOn, true)})` // NB: 'madeUpTo' depricated
  }

  const lastAccountsButton = {
    disabled: !externalLinks || !hubData.pdfLink,
    tipEnabled,
    tipDisabled: !externalLinks
      ? tipEnabled + JARGON.SUBSCRIBED_USERS_ONLY
      : hubData.lseProps
        ? "no Annual Report available"
        : "no accounts available",
    icon: <DescriptionOutlinedIcon />,
    label: annualReportButtonLabel(),
    handleClick: () => { window.open(hubData.pdfLink, "_blank") },
    // Full width, no right padding: this label (e.g. "Annual Report (31 Mar 2026)") needs all
    // the horizontal room it can get to avoid wrapping.
    paddingRight: 0,
    width: "100%",
    fontWeight: "normal",
  }

  return (
    <div>
      {
        <NumerableIconButton item={lastAccountsButton} portrait={portrait} />
      }
    </div >
  )
}
export default AccountsMenu

